import { PM } from '../../constants';
import { defaultFactory as request } from '../../api/RequestFactory';
import { pmRequest } from './requestFactory';
import FSA from '../FSA';

import { ISystemJobs, fetchJobs } from './Job';
import { ISystemSoftware, fetchSoftware } from './Software';

function fetchNodes(requesterId: string, query): any {
    return request.post('me/query', query);
}

function fetchInformation(requesterId: string, containerIds: string[]): any {
    const query = {
        ContainerIdList: containerIds.map((id) => {
            return {
                ContainerId: id
            };
        })
    };

    return pmRequest.post('container/get', query).then((systems) => {
        return systems.reduce((r, system) => {
            r[system.ContainerId] = system;
            return r;
        }, {});
    });
}

function assignInformation(nodes, information) {
    return nodes.map((node) => {
        node.pmInformation = information[node.id];
        return node;
    });
}

export function listSystems(requesterId: string, query?): any {
    return dispatch => {
        dispatch(new FSA(PM.FETCH_SYSTEMS_REQUEST).addMeta({ requesterId, query }).data);

        return fetchNodes(requesterId, query).then(nodes => {
            const containerIds = nodes.map((node) => {
                return node.id;
            });

            return fetchInformation(requesterId, containerIds).then((information) => {
                return assignInformation(nodes, information);
            });
        }).then(nodes => {
            return dispatch(new FSA(PM.FETCH_SYSTEMS_SUCCESS).addPayload(nodes).addMeta({ requesterId, query }).data);
        }).catch(err => {
            dispatch(new FSA(PM.FETCH_SYSTEMS_FAILURE).addError(err).addMeta({ requesterId, query }).data);
            throw err;
        });
    }
}

export function listSystemsWithJobs(requesterId: string, query, softwareParams) {
    return dispatch => {
        dispatch(new FSA(PM.FETCH_SYSTEMS_WITH_JOBS_REQUEST).addMeta({ requesterId, query }).data);

        return fetchNodes(requesterId, query).then(nodes => {
            const containerIds = nodes.map((node) => {
                return node.id;
            });

            return fetchInformation(requesterId, containerIds).then((information) => {
                return assignInformation(nodes, information);
            });
        }).then(nodes => {
            const systemIds = nodes.filter(node => {
                return !!node.pmInformation;
            }).map(node => {
                return node.id;
            });

            softwareParams = softwareParams || {};
            softwareParams.containerIds = systemIds;

            return fetchJobs(requesterId, softwareParams).then(jobs => {
                return dispatch(new FSA(PM.FETCH_SYSTEMS_WITH_JOBS_SUCCESS).addPayload({
                    systems: nodes,
                    jobs
                }).addMeta({ requesterId, query }).data);
            });
        }).catch(err => {
            dispatch(new FSA(PM.FETCH_SYSTEMS_WITH_JOBS_FAILURE).addError(err).addMeta({ requesterId, query }).data);
            throw err;
        });
    }
}

export function listSystemsWithSoftware(requesterId: string, query, softwareParams) {
    return dispatch => {
        dispatch(new FSA(PM.FETCH_SYSTEMS_WITH_SOFTWARE_REQUEST).addMeta({ requesterId, query }).data);

        return fetchNodes(requesterId, query).then(nodes => {
            const containerIds = nodes.map((node) => {
                return node.id;
            });

            return fetchInformation(requesterId, containerIds).then((information) => {
                return assignInformation(nodes, information);
            });
        }).then(nodes => {
            const systemIds = nodes.filter(node => {
                return !!node.pmInformation;
            }).map(node => {
                return node.id;
            });

            softwareParams = softwareParams || {};
            softwareParams.containerIds = systemIds;

            return fetchSoftware(requesterId, softwareParams).then(software => {
                return dispatch(new FSA(PM.FETCH_SYSTEMS_WITH_SOFTWARE_SUCCESS).addPayload({
                    systems: nodes,
                    software
                }).addMeta({ requesterId, query }).data);
            });
        }).catch(err => {
            dispatch(new FSA(PM.FETCH_SYSTEMS_WITH_SOFTWARE_FAILURE).addError(err).addMeta({ requesterId, query }).data);
            throw err;
        });
    }
}


// WEBPACK FOOTER //
// ./src/actions/pm/System.ts